export default 'M19.88 12H3.5V3.81zm2.01-1.8L3.91 1.23Q3.46 1 3 1a2 2 0 0 0-2 2v18a2 2 0 0 0 2.9 1.78l18-8.99a2 2 0 0 0 0-3.58';